import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ConfirmationDialogData, ConfirmationDialogSignal} from "./confirmation-dialog.model";
import {lastValueFrom} from "rxjs";

@Component({
    selector: 'valg-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html'
})
export class ConfirmationDialogComponent {
    title: string;
    description: string;
    descriptionBelowExtraData: string | undefined;
    remarkDescriptionPrefix: string | undefined;
    remarkDescription: string | undefined;
    extraDataPrefix: string | undefined;
    color: string;
    isLockMasterData = false;
    public extraData: string[] | undefined;
    boldDescriptionBelowExtraData = false;


    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: ConfirmationDialogData,
        public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    ) {
        this.title = data.title;
        this.description = data.description;
        this.extraData = data.extraData;
        this.color = data.color;
        this.descriptionBelowExtraData = data.descriptionBelowExtraData;
        this.remarkDescriptionPrefix = data.remarkDescriptionPrefix;
        this.extraDataPrefix = data.extraDataPrefix;
        this.remarkDescription = data.remarkDescription;
        this.warningMessageLockMasterDataDialog();
        this.boldDescriptionBelowExtraData = data.boldDescriptionBelowExtraData ?? false;
    }

    warningMessageLockMasterDataDialog() {
        if (this.title == "municipal_master_data.lock_master_data.dialog.error.header") {
            this.isLockMasterData = true;
        }
    }

  async onCancelClicked() {
    if (this.data.cancelAction) {
      await lastValueFrom(this.data.cancelAction())
    }
    this.dialogRef.close(ConfirmationDialogSignal.Cancel)
  }

    async onContinueClicked() {
        if (this.data.affirmAction) {
            await lastValueFrom(this.data.affirmAction());
        }
        this.dialogRef.close(ConfirmationDialogSignal.Continue)
    }
}
